import { BrowserRouter as Router } from "react-router-dom";
import HeaderComponent from "./components/HeaderComponent";
import FooterComponent from "./components/FooterComponent";

import "./index.css";
import RoutesProvider from "./providers/route/routes.provider";

const App = () => {
  return (
    <div className="appContainer">
      <Router>
        <HeaderComponent />
        <div className="contentContainer">
          <RoutesProvider />
        </div>
        <FooterComponent />
      </Router>
    </div>
  );
};

export default App;
